import { connect } from "react-redux";

import UserOverviewContainer from "./UserOverviewContainer";
import roleTypes from "../../constants/roles";

const mapStateToProps = state => {
    const isAdmin = state.user.profile.roles.includes(roleTypes.admin);

    return {
        isAdmin
    };
};

export default connect(mapStateToProps)(UserOverviewContainer);
